import { gridTypes } from './constants';

class FeatureAvailabilityService {
    private _planType: 'free' | 'trial' | 'pro';
    constructor() {
        this._planType = 'free';
    }

    setPlanType(planType: FeatureAvailabilityService['_planType']) {
        this._planType = planType;
    }

    get isTestStatusEnabled() {
        return ['pro', 'trial'].includes(this._planType);
    }

    shouldShowFreeGridRunWarning(gridType: string | undefined) {
        return this._planType !== 'pro' && gridType === gridTypes.DEVICE_FARM;
    }
}

export const featureAvailabilityService = new FeatureAvailabilityService();
